import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { Provider } from 'react-redux';
import { store } from './state/slices/store';

import App from './App';

const auth0API = process.env.REACT_APP_AUTH0_AUTHORIZATION_API;
const clientId = process.env.REACT_APP_AUTH0_CLIENTID;

ReactDOM.createRoot(document.getElementById('root')).render(
    <Auth0Provider
        domain="insightshippinginc.us.auth0.com"
        clientId={clientId}
        authorizationParams={{
            // redirect_uri: 'http://localhost:3000',
            redirect_uri: window.location.origin,
            audience: auth0API,
        }}
        useRefreshTokens={true}
        cacheLocation="localstorage"
    >
        <Provider store={store}>
            <App />
        </Provider>
    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
